import { Chart } from 'chart.js/auto'

class PieChart extends HTMLElement {
  #shadow: ShadowRoot
  #canvas?: HTMLCanvasElement
  datasets: any
  width: number
  height: number

  constructor() {
    super()
    this.#shadow = this.attachShadow({ mode: 'open' })
    this.width = 400
    this.height = 300
  }

  connectedCallback() {
    this.#render()
  }

  #render() {
    const datasets = this.datasets.toArray()
    const emptyState =
      datasets.length > 0
        ? datasets
        : [
            {
              colors: { toArray: () => ['#F5F6F6'] },
              data: { toArray: () => [100] },
              labels: { toArray: () => ['Default'] },
            },
          ]
    const wrapper = document.createElement('div')
    wrapper.style.position = 'relative'
    wrapper.style.maxWidth = '400px'
    wrapper.style.maxHeight = '200px'
    this.#canvas = document.createElement('canvas')
    this.#canvas.width = this.width
    this.#canvas.height = this.height
    wrapper.appendChild(this.#canvas)
    this.#shadow.appendChild(wrapper)

    const labels = emptyState[0].labels.toArray()
    new Chart(this.#canvas, {
      type: 'doughnut',
      data: {
        labels,
        datasets: emptyState.map((dataset: any) => ({
          backgroundColor: dataset.colors.toArray(),
          data: dataset.data.toArray(),
        })),
      },
      options: {
        responsive: true,
        animation: false,
        events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
        datasets: {
          doughnut: { borderRadius: 5 },
        },
        elements: {
          arc: { borderAlign: 'inner', circular: true },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                // Affiche la valeur brute au survol
                const value = context.parsed
                return `${context.label}: ${value}`
              },
            },
          },
        },
      },
    })
  }

  // Lifecycle functions.
  disconnectedCallback() {}
  adoptedCallback() {}
  attributeChangedCallback() {}
}

export function register() {
  customElements.define('pie-chart', PieChart)
}
